import { Navigation as RivendellNavigation, Separator } from '@nordlayer/rivendell-ui';
import { useFeatures } from 'flagged';
import { useAbility } from '@nordvpn/teams.core/lib/atoms/Permissions';
import { Features } from 'types/features/enums';
import { useFeatureFlag } from 'utils/useFeatureFlag';
import { useAreFeaturesLoaded } from 'api/FeatureFlags/queries';
import { NavigationItem } from './NavigationItem';
import { UserProfileNavigationItem } from './UserProfileNavigationItem';
import { getNavigationItems } from './constants';
import { filterVisibleItems } from './utils';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var Navigation = function Navigation(_ref) {
    var isDesktop = _ref.isDesktop, fullName = _ref.fullName;
    var areFeaturesLoaded = useAreFeaturesLoaded();
    var isUsersManagementEnabled = useFeatureFlag(Features.UsersManagement);
    var isDistributorsEnabled = useFeatureFlag(Features.Distributors);
    var features = useFeatures();
    var ability = useAbility();
    var shouldRenderRedesignedUsersManagement = areFeaturesLoaded && isUsersManagementEnabled;
    var shouldRenderDistributors = areFeaturesLoaded && isDistributorsEnabled;
    var navigationItems = filterVisibleItems(getNavigationItems(shouldRenderRedesignedUsersManagement, shouldRenderDistributors), features, ability);
    return /*#__PURE__*/ _jsxs(RivendellNavigation, {
        children: [navigationItems.map(function (item, index) {
                return /*#__PURE__*/ _jsx(NavigationItem, {
                    item: item
                }, index);
            }), !isDesktop && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [/*#__PURE__*/ _jsx(Separator, {}), /*#__PURE__*/ _jsx(UserProfileNavigationItem, {
                        fullName: fullName
                    })]
            })]
    });
};
